import { EntitySelectorsFactory } from "@ngrx/data";
import { createSelector } from "@ngrx/store";
import { selectListingSK, selectListingSKByListingId } from "./listing-summary.selectors";
import { ListingPermission } from "./shared/interfaces/listing-permission";

export const listingPermissionSelectors = new EntitySelectorsFactory().create<ListingPermission>(
	"ListingPermission"
);

const selectListingPermissionsByListingSKFn = (
	listingSK: ListingPermission["listingSK"],
	listingPermissions: ListingPermission[]
): ListingPermission[] => {
	return listingPermissions.filter((lp) => lp.listingSK === listingSK);
};

export const selectListingPermissionsByListingId = (listingId: string) =>
	createSelector(
		selectListingSKByListingId(listingId),
		listingPermissionSelectors.selectEntities,
		selectListingPermissionsByListingSKFn
	);

export const selectListingPermissions = createSelector(
	selectListingSK,
	listingPermissionSelectors.selectEntities,
	selectListingPermissionsByListingSKFn
);
